<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table [name]="name" [endpoint]="endpoint()" [chartColumn]="'Activity'"></app-api-table>
  }
</app-tab-layout>
